import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "graphql/mutations";
import {
  listPrintSizes,
  createPrintSize,
  updatePrintSize,
  deleteCampaignPrintSizes,
} from "services/apiMiddleware";
import { replaceArrayItem } from "services/utils";
import _ from "lodash";
import { t } from "../../i18n";

const printSizes = {
  state: {
    isLoading: false,
    error: null,
    items: [],
  },
  reducers: {
    loadStart: (state) => {
      return {
        ...state,
        isLoading: true,
      };
    },
    loadSuccess: (state, items) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items,
      };
    },
    createSuccess: (state, newItem) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: [...state.items, newItem],
      };
    },
    updateSuccess: (state, updatedItem) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: replaceArrayItem(state.items, (item) => item.id === updatedItem.id, updatedItem),
      };
    },
    deleteSuccess: (state, deletedId) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        items: state.items.filter((item) => item.id !== deletedId),
      };
    },
    failure: (state, error) => {
      return {
        ...state,
        isLoading: false,
        error,
      };
    },
  },
  effects: (dispatch) => ({
    async load() {
      try {
        dispatch.printSizes.loadStart();
        const { data, errorMessage } = await listPrintSizes();
        dispatch.printSizes.loadSuccess(data);
        if (errorMessage) console.warn(errorMessage);
      } catch (error) {
        console.error(error);
        dispatch.printSizes.failure(t("print_sizes_load_error", { ns: "common" }));
      }
    },
    async create(createProps) {
      try {
        dispatch.printSizes.loadStart();
        const { data, errorMessage } = await createPrintSize(createProps);
        if (errorMessage) console.warn(errorMessage);
        dispatch.printSizes.createSuccess(data);
        return data;
      } catch (error) {
        dispatch.printSizes.failure(t("print_size_create_failure", { ns: "common" }));
        throw error;
      }
    },
    async update(updateProps) {
      try {
        dispatch.printSizes.loadStart();
        const { data, errorMessage } = await updatePrintSize(updateProps);
        if (errorMessage) console.warn(errorMessage);
        dispatch.printSizes.updateSuccess(data);
        return data;
      } catch (error) {
        dispatch.printSizes.failure(t("print_size_update_failure", { ns: "common" }));
        throw error;
      }
    },
    async delete(printSize) {
      try {
        dispatch.printSizes.loadStart();

        // First, delete the print size's entries from CampaignPrintSize join table
        const campaignPrintSizeIdsToDelete = _.map(printSize.campaigns.items, "id");
        await deleteCampaignPrintSizes(campaignPrintSizeIdsToDelete);

        // Then, delete the print size
        const result = await API.graphql(
          graphqlOperation(mutations.deletePrintSize, { input: { id: printSize.id } })
        );
        const deletedId = result.data.deletePrintSize.id;
        dispatch.printSizes.deleteSuccess(deletedId);
      } catch (error) {
        dispatch.printSizes.failure(t("print_size_delete_failure", { ns: "common" }));
        throw error;
      }
    },
  }),
};

export default printSizes;
